import { CLEAN_MTOKNA_NEWSLETTER, FETCH_MTOKNA_NEWSLETTER } from '../actions/types';

const MTOKNA_NEWSLETTER_DEFAULT_STATE = {};

/**
 * Reducer pre sablonu.
 */
const MtoknaNewsletterReducer = (state = MTOKNA_NEWSLETTER_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_NEWSLETTER:
            // Nacitanie sablony
            return payload;

        case CLEAN_MTOKNA_NEWSLETTER:
            // Vycistenie sablony
            return MTOKNA_NEWSLETTER_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaNewsletterReducer;
